

import React from 'react'
import TablaNotificaciones from '../../../components/TablaNotificaciones/TablaNotificaciones'
import { Select, Layout, } from "antd";
import { Header } from "../../../components/Landing/Header/haeder.view";
import { BannerPanel } from "../../Usuario/components/BannerPanel";
import { MenuUsuario } from "../../Usuario/components/MenuUsuario";
const { Option } = Select;
const { Content } = Layout;
const NotificacionesUsuario = () => {
return (
<div>
   <Header />
   <BannerPanel />
   <div
   className="container-fluid2"
   style={{ paddingTop: "16px", paddingBottom: "5%" }}
   >
   <div className="row">
      <MenuUsuario activeItem={4} />
      <div className="col-12 col-lg-10">
         <Content className="eval_pro_containt_area p-1 ">
            <TablaNotificaciones/>
         </Content>
      </div>
   </div>
   <Content className="footer-bar">
      {/*    
      <Footer />
      */}
   </Content>
</div>
</div>
)
}
export default NotificacionesUsuario

